import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { SlimScrollOptions, Incident, Person } from "app/shared/shared.module";

import { Location } from "app/common/location";
import { Subscription } from "rxjs/Subscription";
import { PersonService } from "app/person/person.service";

@Component({
	selector: 'app-person-details',
	templateUrl: './person-details.component.html',
	styleUrls: ['./person-details.component.css']
})
export class PersonDetailsComponent implements OnInit {

    Today: Date = new Date();

	MedicinesFilter: string = "";
    AllergyFilter: string = "";

    SelectedLocation: Location;

    PersonId: any;
	Person: Person;

    SlimScrollOptions = SlimScrollOptions;
    sub: Subscription;
    GetPersonDetailsSubscription: Subscription;

    constructor(private personService: PersonService, private route: ActivatedRoute) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            if (params && params['id']) {
                this.PersonId = params['id'];
                this.GetDetails();
            }
        })
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
        if (this.GetPersonDetailsSubscription != null) {
            this.GetPersonDetailsSubscription.unsubscribe();
        }
    }

    GetDetails() {
        this.personService.GetPersonDetails(this.PersonId).subscribe(
            person => {
                this.Person = person;
            }, err => {
                console.log(err);
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/person/details/person-details.component.ts